const BASE_URL = process.env.VUE_APP_BASE_URL || "https://api.shepa.com/";
const myShepa = process.env.VUE_APP_MY_SHEPA || "https://my.shepa.com/";
const strategyApi = process.env.VUE_APP_STRATEGY_BASE_URL;
const transferApi = process.env.VUE_APP_TRANSFER_BASE_URL;
const homeUrl = "http://shepa.com/"

export const routesMap = {
  base: BASE_URL,
  strategyApi: strategyApi,
  transferApi: transferApi,
  file: BASE_URL + "api/files/",
  admin: BASE_URL + "api/admin/",
  api: BASE_URL + "api/",
  download: BASE_URL + "download",
  BankImage: myShepa + "media/BankImage/",
  myShepa: myShepa,
  homeUrl:homeUrl ,
  outrules: homeUrl + 'shepa_international_rules/',
  inrules: homeUrl + 'shepa_rules/',
};
export default routesMap;
